// Import standards
import { useState } from "react";
import { Link } from "react-router-dom";

// Bulma COmponents
import { Card, Columns, Heading, Media, Image } from "react-bulma-components";

// Short-hand calls
const { Column } = Columns;

// Country card component
const CountryCard = (props) => {
    const [transition, setTransition] = useState(false);

    // handle onMouseEnter and onMouseLeave on card
    const handleTransition = () => {
        setTransition(!transition);
    }

    // css for when mouse entering search input
    const enter = {
        transform: "scale(1.03)",
        boxShadow: "rgb(136 166 225 / 74%) 0px 0.5em 1em -0.125em, rgb(45 89 181 / 52%) 0px 0px 0px 1px",
        transition: "transform .1s ease-in-out, box-shadow .7s ease-out"
    };

    // css for when mouse leaivng search input
    const leave = {
        transform: "scale(1)",
        boxShadow: "0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)"
    };

    return (
        // Displays data as a column
        <Column display={props.display} size={props.size}>
            {/* Use Card Template from Bulma to settle data into */}
            <Card style={transition ? enter : leave} onMouseEnter={handleTransition} onMouseLeave={handleTransition}>
                <Card.Image size="16by9" renderAs={Link} to={`/country/${props.name}`} src={props.flags}/>
                <Card.Content>
                    {/* Display country name and coat of arms */}
                    <Media>
                        {(props.coatOfArms) ? 
                            <Media.Item align="left" renderAs="figure">
                                <Image src={props.coatOfArms} size={32}/>
                            </Media.Item> :
                            ""
                        }
                        <Media.Item>
                            <Heading size={4} renderAs={Link} to={`/country/${props.name}`}>
                                {props.name}
                            </Heading>
                        </Media.Item>
                    </Media>

                </Card.Content>
                {/* Country's summarised details */}
                <Card.Footer>
                    <Card.Footer.Item className="is-size-7">Region: {props.region}
                    </Card.Footer.Item>
                    <Card.Footer.Item className="is-size-7">Capital: {props.capital}</Card.Footer.Item>
                    <Card.Footer.Item className="is-size-7">Population: {props.population.toLocaleString('en-US')}</Card.Footer.Item>
                </Card.Footer>
            </Card>
        </Column>
    );
};

export default CountryCard;